<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Parking and Tolls</h1>
      <v-btn @click="create" color="green" dark class="text-none">Create</v-btn>
    </v-layout>
    <v-layout pt-3 justify-center>
      <v-flex xs12 md8>
        <SimpleCard>
          <LocationAdditionalCharges :locationAdditionalCharges="locationAdditionalCharges"/>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import LocationAdditionalCharges from "@/components/settings/pricing/LocationAdditionalCharges.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "parking_and_tolls",
  components: {
    Overview,
    SimpleCard,
    LocationAdditionalCharges
  },
  data: function() {
    return {
      locationAdditionalCharges: []
    };
  },
  methods: {
    create: function() {
      this.$router.push("/settings/pricing/parking_and_tolls/create");
    }
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/location_additional_charge/all`;

      let response = await axios.get(url, {
        params: {}
      });

      this.locationAdditionalCharges = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get history");
    }
  }
};
</script>
